/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch-helper/~/lodash/_freeGlobal.js
// module id = 48
// module chunks = 0